export default __webpack_public_path__ + "static/log-axis-edbabe3ffdf780f7ef534c5c74948f77.png";